/**
 * Stable CSS class names for E2E — ShippingListStatusManagement page.
 * Containers use `shipping-list-status-management__<element>`; inputs and
 * user-interactable controls use `shipping-list-status-management-input--<name>`.
 */
export const SLSM = {
    page: 'shipping-list-status-management-page',
    root: 'shipping-list-status-management',

    header: 'shipping-list-status-management__header',
    breadcrumb: 'shipping-list-status-management__breadcrumb',

    body: 'shipping-list-status-management__body',
    panel: 'shipping-list-status-management__panel',
    panelBody: 'shipping-list-status-management__panel-body',

    section: 'shipping-list-status-management__section',
    sectionFromStatus: 'shipping-list-status-management__section--from-status',
    sectionAllowedStatus: 'shipping-list-status-management__section--allowed-status',
    sectionRoles: 'shipping-list-status-management__section--roles',
    sectionLabel: 'shipping-list-status-management__section-label',
    sectionLabelIcon: 'shipping-list-status-management__section-label-icon',
    sectionTitle: 'shipping-list-status-management__section-title',

    inputFromStatus: 'shipping-list-status-management-input--from-status',
    fromStatusOption: 'shipping-list-status-management__from-status-option',

    transitionDivider: 'shipping-list-status-management__transition-divider',
    transitionDividerLine: 'shipping-list-status-management__transition-divider-line',
    transitionDividerIcon: 'shipping-list-status-management__transition-divider-icon',

    allowedStatusControl: 'shipping-list-status-management__allowed-status-control',
    inputAllowedStatus: 'shipping-list-status-management-input--allowed-status',
    allowedStatusOption: 'shipping-list-status-management__allowed-status-option',

    rolesHeader: 'shipping-list-status-management__roles-header',
    rolesHeaderTitle: 'shipping-list-status-management__roles-header-title',
    selectedCountChip: 'shipping-list-status-management__selected-count-chip',
    rolesList: 'shipping-list-status-management__roles-list',
    rolesFieldset: 'shipping-list-status-management__roles-fieldset',
    rolesGroup: 'shipping-list-status-management__roles-group',
    roleRow: 'shipping-list-status-management__role-row',
    roleRowChecked: 'shipping-list-status-management__role-row--checked',
    inputRoleCheckbox: 'shipping-list-status-management-input--role-checkbox',
    roleLabel: 'shipping-list-status-management__role-label',

    actionBox: 'shipping-list-status-management__action-box',
    btnSave: 'shipping-list-status-management-input--button-save',
} as const;

export const slsmCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
